import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Box } from "@mui/material";
import Header from "../pages/Header";
import moviesStore from "../stores/moviesStore";
import MainBody from "./MainBody";
import Pagination from "./Pagination";
import MainBodyFilter from "../components/MainBodyFilter";
import PortalNavigation from "./PortalNavigation";

const AppWrapper: React.FC = observer(() => {
  const [filterString, setFilterString] = useState("");

  const handleApplyFilters = (str: string) => {
    setFilterString(str);
    moviesStore.fetchMovies(1, undefined, str); // передаем строку фильтров
  };

  useEffect(() => {
    // первый запрос на страницу 1
    moviesStore.fetchMovies(1);
  }, []);

  return (
    <Box height="100vh" display="flex" flexDirection="column">
      {/* Верхний Header */}
      <Header />

      {/* Контент */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
        p={2}
      >
        <PortalNavigation />

        {/* компонент фильтра */}
        <MainBodyFilter
          onApplyFilters={(str) => {
            setFilterString(str); // сохраняем строку фильтров
            moviesStore.fetchMovies(1, undefined, str); // передаем строку в store
          }}
        />

        {/* Список фильмов */}
        <MainBody movies={moviesStore.movies} loading={moviesStore.loading} />

        {/* Пагинация */}
        <Pagination
          currentPage={moviesStore.currentPage}
          totalPages={moviesStore.totalPages}
          onChange={(page) =>
            moviesStore.fetchMovies(page, undefined, filterString)
          }
        />
      </Box>
    </Box>
  );
});

export default AppWrapper;
